import '@ipfabric/shared-public/tailwind/css/preflight.min.css';
import 'public/css/bootstrap.min.css';

import '@ipfabric/shared-public/fontawesome/css/fontawesome.min.css';
import '@ipfabric/shared-public/fontawesome/css/duotone.min.css';
import '@ipfabric/shared-public/fontawesome/css/light.min.css';
import '@ipfabric/shared-public/fontawesome/css/regular.min.css';
import '@ipfabric/shared-public/fontawesome/css/solid.min.css';
import '@ipfabric/shared-public/fontawesome/css/thin.min.css';

import '@ipfabric/shared-public/fonts/css/fonts.css';

import 'public/AdminLTE/AdminLTE.min.css';
import 'public/AdminLTE/skins/skin-purple.min.css';
